
import HelperEnv from '../helpers/HelperEnv';
import HelperApis from '../helpers/HelperApis';
import HelperVehicle from '../helpers/HelperVehicle';
import { rejectPostsUnauthorised } from './actionsApi';

export const REQUEST_POSTS_FINANCEFILE = 'REQUEST_POSTS_FINANCEFILE';
export const RECEIVE_POSTS_FINANCEFILE = 'RECEIVE_POSTS_FINANCEFILE';
export const REJECT_POSTS_FINANCEFILE = 'REJECT_POSTS_FINANCEFILE';

export function fetchFinanceFileIfNeeded(state, dispatch, context, vehicle, parameters, force) {
	if (context == null && state.testCriteria.context != null) {
		context = state.testCriteria.context;
	}
	if (vehicle == null && state.testCriteria.vehicle != null) {
		vehicle = state.testCriteria.vehicle;
	}
	if (parameters == null && state.testCriteria.parameters != null) {
		parameters = state.testCriteria.parametersForFetch;
	}
	if (parameters === '') {
		parameters = null;
	}
	if (shouldFetchFinanceFile(vehicle) || force) {
		return fetchFinanceFile(dispatch, context, vehicle, parameters, state.env, state.settings)
	}
	return null;
}

function requestPostsFinanceFile() {
	return { type: REQUEST_POSTS_FINANCEFILE }
}
function rejectPostsFinanceFile() {
	return { type: REJECT_POSTS_FINANCEFILE }
}
function receivePostsFinanceFile(responseFinanceFile) {
	return {
		type: RECEIVE_POSTS_FINANCEFILE,
		payload: { responseFinanceFile }
	}
}

function shouldFetchFinanceFile(vehicle) {
	return HelperVehicle.isEnoughForCalculation(vehicle);
}
function fetchFinanceFile(dispatch, context, vehicle, parameters, env, settings) {
	dispatch(requestPostsFinanceFile());
	var url = HelperEnv.getUrlBaseFinanceFile(settings) + HelperEnv.getUriFinanceFile(settings);
	var contextCall = HelperApis.getContextAPICall(context, settings, true);
	var request = {
		context: contextCall,
		vehicle: HelperVehicle.getVehicleResourceSingle(vehicle, settings.vehDescType)
	};
	if (parameters != null && Object.keys(parameters).length > 0) {
		request.parameters = parameters;
	}
	var headers = HelperApis.getHeaderBasicAuth(HelperApis.getBasicAuth(env), HelperEnv.getFinanceFileClientId(settings));
	fetch(url, {
		method: 'post',
		headers: headers,
		body: JSON.stringify(request)
	}).then(res => {
		if (res.status !== 200) {
			dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
		}
		if (!res.ok) {
			dispatch(rejectPostsFinanceFile());
		} else {
			return res.json()
		}
		return null;
	}).catch((error) => {
		dispatch(rejectPostsUnauthorised({ error: error }));
	}).then(
		json => {
			dispatch(receivePostsFinanceFile(json))
		}
	);
}
